import store from '@/store';

const CONTEXT_HEADER = 'App-Context';

const contextInterceptor = (config) => {
  /* eslint-disable no-param-reassign */
  const entidade = store.getters['entidade/entidade'];

  if (!config.headers[CONTEXT_HEADER] && entidade) {
    config.headers[CONTEXT_HEADER] = btoa(entidade.id);
  }

  return config;
};

export default contextInterceptor;
